module.exports = __webpack_public_path__ + "img/travelone-logo.3d574a97.svg";